import { Link } from "react-router-dom";

import type { PackageLot } from "../api/types";
import { adena } from "../format";
import { traderHref } from "../search/nav";
import { LotItems } from "./LotItems";

/** The package-lot table, shared by the scan index and the packages page.
 *  Keyed on nick + observed_at + total: nick + total alone collides when one
 *  trader posts two lots at the same price, which is silent data loss dressed
 *  up as a React key warning.
 *
 *  `showTrader` is false on a trader's own page, where the column would be the
 *  same name in every row — the constant-column problem the mode pages' Town
 *  had. A prop rather than a third copy of this table: two copies were already
 *  de-duplicated into this one, and they had drifted before anyone noticed. */
export function LotsTable({ lots, showTrader = true }: {
  lots: PackageLot[];
  showTrader?: boolean;
}) {
  return (
    <div className="scroll">
      <table>
        <thead>
          <tr>
            {showTrader ? <th>Trader</th> : null}
            <th className="num">Lot price</th>
            <th className="num">Items</th>
            <th>Included</th>
          </tr>
        </thead>
        <tbody>
          {lots.map((lot) => (
            <tr key={`${lot.nick}-${lot.observed_at}-${lot.total ?? "unpriced"}`}>
              {showTrader ? <td><Link to={traderHref(lot.nick)}>{lot.nick}</Link></td> : null}
              {/* No buy/sell hue: a lot is neither a bid nor an ask. */}
              <td className="num">{adena(lot.total)}</td>
              <td className="num dim">{lot.items.length}</td>
              <td>
                <LotItems items={lot.items} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
